<div class="f-container f-stack-vertical text-center card" style="background: linear-gradient(45deg, white, lightgray);">
  <div class="f-centered-container">
    <h2 class="fa fa-5x {{icon}}"></h2>
  </div>
  <div class="card-block">
    <h4 style="font-weight: 400" class="card-title">{{title | translate}}</h4>
    <p class="card-text">{{description ? '' : ' &nbsp;'}}{{description | translate}}</p>
    <a [routerLink]=link class="btn btn-w-md btn-line-info">{{buttonText | translate}}</a>
  </div>
</div>